const local_data_seguimentos = data_seguimentos;
var data_subseguimentos_por_seguimentos = data_subseguimentos_por_seguimentos;
let filtrosSelecionados = 0;
let alterouTipoEntregaMobile = false;
let alterouSegmentoMobile = false;
let alterouSegmento = false;
let alterouTipoEntrega = false;
let alterouLetra = false;
let reservasLoja;
let idLojaGlobal;
let nomeLojaGlobal;
const isAlimentacao = document.currentScript.getAttribute('data-is-alimentacao') === 'true';
const isRestaurante = document.currentScript.getAttribute('data-is-restaurante') === 'true';

Array.prototype.naturalSort = function () {
  // Ordena o array atual utilizando um algoritmo de ordenação natural.
  // Ele compara os elementos do array considerando tanto caracteres numéricos quanto caracteres alfabéticos, garantindo uma ordem correta mesmo para sequências mistas de números e letras.
  // O algoritmo também lida com acentos e caracteres especiais, normalizando-os antes da comparação. O array é ordenado diretamente, sem a necessidade de um argumento de comparação personalizado.
  // Este método pode ser usado em um array para ordenar seus elementos em ordem natural, em vez da ordem lexicográfica padrão oferecida pelo método 'sort()' nativo do JavaScript.

  const segmentPattern = /(\d+)|(\D+)/g;
  const digitPattern = /\d+/;

  return this.sort((a, b) => {
    const segmentMatchesA = String(a.nome).toLowerCase().match(segmentPattern);
    const segmentMatchesB = String(b.nome).toLowerCase().match(segmentPattern);

    while (segmentMatchesA.length && segmentMatchesB.length) {
      const segmentA = segmentMatchesA
        .shift()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
      const segmentB = segmentMatchesB
        .shift()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');

      if (digitPattern.test(segmentA) || digitPattern.test(segmentB)) {
        if (!digitPattern.test(segmentA)) return -1;
        if (!digitPattern.test(segmentB)) return 1;
        if (segmentA !== segmentB) return segmentA - segmentB;
      } else if (segmentA !== segmentB) {
        const firstCharIsLetterA = segmentA[0].charAt(0).match(/[a-z]/i);
        const firstCharIsLetterB = segmentB[0].charAt(0).match(/[a-z]/i);

        if (firstCharIsLetterA && !firstCharIsLetterB) return -1;
        if (!firstCharIsLetterA && firstCharIsLetterB) return 1;
        return segmentA[0] === segmentB[0] ? 0 : segmentA[0] < segmentB[0] ? -1 : 1;
      }
    }

    return segmentMatchesA.length - segmentMatchesB.length;
  });
};

const fillSegments = data => {
  const objSegmentos = Object.entries(data_subseguimentos_por_seguimentos);

  objSegmentos.sort(([a], [b]) => a.localeCompare(b));

  objSegmentos.forEach(([segmento]) => {
    const capitalizedSegmento = segmento.charAt(0).toUpperCase() + segmento.slice(1).toLowerCase();

    const filtroSegmentoHTML = `
      <li>
        <a data-tipofiltro="SEGMENTO" class="clickFiltroSegmento" onclick="clickSegmento(this); dataLayerSegmento(this)" data-segmentoFiltro="${segmento}" href="javascript:;">
          ${capitalizedSegmento}
          <span class='subsegmento__stores--qtd'></span>
        </a>
      </li>`;

    $('#filtroSegmentos').append(filtroSegmentoHTML);

    const filtroSegmentoMobileHTML = `
      <option data-tipofiltro="SEGMENTO" class="clickFiltroSegmento" onclick="clickSegmento(this); dataLayerSegmento(this)" value="${segmento}">
        ${capitalizedSegmento}
      </option>`;

    $('#filtroSegmentosMobile').append(filtroSegmentoMobileHTML);
  });
};

const fillSubSegments = data => {
  const objSegmentos = Object.entries(data_subseguimentos_por_seguimentos);

  objSegmentos.sort(([a], [b]) => a.localeCompare(b));

  objSegmentos.forEach(([segmento, subsegments]) => {
    if (segmento === 'ALIMENTAÇÃO') {
      subsegments.sort((a, b) => a.localeCompare(b));

      subsegments.forEach(subsegmento => {
        const subsegmentoCapitalized =
          subsegmento.charAt(0).toUpperCase() + subsegmento.slice(1).toLowerCase();

        if (subsegmento.toUpperCase() !== 'RESTAURANTES') {
          const filtroSubSegmentoHTML = `
          <li>
            <a data-tipofiltro="SUBSEGMENTO" class="clickFiltroSubSegmento" onclick="clickSegmento(this); dataLayerSubSegmento('${segmento}','${subsegmento}')" data-subSegmentoFiltro="${subsegmento}" href="javascript:;">
              ${subsegmentoCapitalized}
              <span class='subsegmento__stores--qtd'></span>
            </a>
          </li>`;

          const filtroSubSegmentoMobileHTML = `
          <option data-tipofiltro="SUBSEGMENTO" class="clickFiltroSubSegmento" onclick="dataLayerSubSegmento('${segmento}','${subsegmento}')" value="${subsegmento}">
            ${subsegmentoCapitalized}
          </option>`;

          $('#filtroSegmentos').append(filtroSubSegmentoHTML);
          $('#filtroSegmentosMobile').append(filtroSubSegmentoMobileHTML);
        } else {
          const filtroRestaurantesHTML = `
          <li>
            <a data-tipofiltro="SUBSEGMENTO" class="clickFiltroSubSegmento" onclick="window.location.href = '/restaurantes';" data-subSegmentoFiltro="${subsegmento}" href="javascript:;">
              ${subsegmentoCapitalized}
              <span class='subsegmento__stores--qtd'></span>
            </a>
          </li>`;

          const filtroRestaurantesMobileHTML = `
          <option data-tipofiltro="SUBSEGMENTO" class="clickFiltroSubSegmento" value="${subsegmento}">
            ${subsegmentoCapitalized}
          </option>`;

          $('#filtroSegmentos').append(filtroRestaurantesHTML);
          $('#filtroSegmentosMobile').append(filtroRestaurantesMobileHTML);
        }
      });
    }
  });
};

const getLetraFiltro = letra => {
  letra = letra.toUpperCase();

  if (/[0-9]/.test(letra)) {
    return '0-9';
  }

  const normalizedLetter = letra.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  if (/[^\w-]/.test(normalizedLetter)) {
    return 'SPECIAL';
  }

  return normalizedLetter;
};

const processStores = (data, isAlimentacao) => {
  let letraFiltroOld = '';
  let htmlLojas = '';

  data.sort((a, b) => a.nome.localeCompare(b.nome));
  data = data.naturalSort();

  data.forEach((store, index) => {
    const nomeLoja = store.nome;
    const letraFiltro = getLetraFiltro(nomeLoja.substring(0, 1));

    htmlLojas += buildStore(store, letraFiltro, letraFiltroOld, index, data.length);

    letraFiltroOld = letraFiltro;

    if (data.length - 1 === index) {
      const loadingIndicator = $('#loadingIndicator');
      $(htmlLojas).insertBefore(loadingIndicator);

      if (isAlimentacao) {
        fillSubSegments(data);
        carregaQtdLojasSubSegmentos();
      } else {
        fillSegments(data);
        carregaQtdLojasSegmentos();
      }

      carregaQtdLojasTipoEntrega();
      filterURL();
    }
  });
};

const fetchData = () => {
  const url = '/lojas_files/lojas.json?paramRandom=' + Math.random();

  return new Promise((resolve, reject) => {
    $.getJSON(url, data => {
      resolve(data);
    }).fail((jqXHR, textStatus, errorThrown) => {
      reject(errorThrown);
    });
  });
};

const filterData = (data, isAlimentacao, isRestaurante) => {
  if (isAlimentacao && !isRestaurante)
    return data.filter(store => store.categoria[0] === 'ALIMENTAÇÃO');

  if (isAlimentacao && isRestaurante)
    return data.filter(store => store.itensSeguimento[0].subseguimento === 'RESTAURANTES');

  return data;
};

const generateOptions = (isAlimentacao, isRestaurante) => {
  const options = {
    url: '/lojas_files/lojas.json?paramRandom=' + Math.random(),
    getValue: isAlimentacao
      ? element => {
          if (!isRestaurante && element.categoria[0] === 'ALIMENTAÇÃO') {
            return element.nome;
          } else if (isRestaurante && element.itensSeguimento[0].subseguimento === 'RESTAURANTES') {
            return element.nome;
          } else {
            return '';
          }
        }
      : 'nome',
    list: {
      match: {
        enabled: true,
      },
    },
  };
  return options;
};

fetchData()
  .then(data => {
    const filteredData = filterData(data, isAlimentacao, isRestaurante);
    const options = generateOptions(isAlimentacao, isRestaurante);

    processStores(filteredData, isAlimentacao, isRestaurante);
    $('#storeSearch').easyAutocomplete(options);
  })
  .catch(error => {
    console.error(error);
  });

function atualizaNumeroFiltrosSelecionados() {
  $('.store-page__filter__selected--number').text(filtrosSelecionados);

  if (filtrosSelecionados === 0) {
    limpaTodosFiltros();
  } else if (!$('#limparFiltros').is(':visible')) {
    $('#limparFiltros').show();
  }
}

function limpaTodosFiltros() {
  const storeSearch = $('#storeSearch');
  const storesContainer = $('.store-page__stores--container');
  const quickFilters = $('.clickFiltroRapido');
  const deliveryTypes = $('#filtroTipoEntrega a');
  const segmentFilters = $('.clickFiltroSegmento, .clickFiltroSubSegmento');
  const letterFilters = $('#letraDoFiltro a');
  const segmentFilterMobile = $('#filtroSegmentosMobile option:first');
  const deliveryTypeMobile = $('#filtroTipoEntregaMobile option:first');
  const limparFiltros = $('#limparFiltros');
  const selectedNumber = $('.store-page__filter__selected--number');

  storeSearch.val('');
  storesContainer.removeClass('hidden-container');
  quickFilters.removeClass('active-quick-filter selected');
  deliveryTypes.removeClass('active-delivery selected');
  segmentFilters.removeClass('active-segmento selected');
  letterFilters.removeClass('active-letra selected');
  segmentFilterMobile.prop('selected', 'selected');
  deliveryTypeMobile.prop('selected', 'selected');
  limparFiltros.hide();
  selectedNumber.text('0');

  alterouTipoEntregaMobile = false;
  alterouSegmentoMobile = false;
  alterouSegmento = false;
  alterouTipoEntrega = false;
  alterouLetra = false;
  filtrosSelecionados = 0;

  filtraLoja();

  $('.store-page__stores--item').removeClass('not-filtered');
}

function filtraLoja(filtroNome) {
  const storeItems = $('.store-page__stores--item');
  const storesContainer = $('.store-page__stores--container');
  const noStores = $('.nostores');
  const infoLetras = $('.infoLetra');
  const loadingLoja = $('#loadingLoja');

  storeItems.hide();
  storesContainer.addClass('hidden-container');
  noStores.hide();
  infoLetras.hide();
  loadingLoja.show();

  processaLoja(storeItems, false, filtroNome);

  const lojasFiltradas = $('.store-page__stores--item:visible');

  if (!lojasFiltradas || lojasFiltradas.length === 0) {
    noStores.show();
  } else {
    lojasFiltradas.each(function () {
      const storeImage = $(this).find('.store-detail__image');
      const letra = $(this).attr('data-letra');

      storeImage.attr(
        'style',
        'cursor: pointer; background-image: url(' + storeImage.attr('data-src') + ')',
      );

      $('#infoLetra-' + letra).show();
      $(`.store-page__stores--container[data-letra="${letra}"]`).removeClass('hidden-container');
    });
  }

  loadingLoja.hide();
}

function processaLoja(element, isScroll, filtroNome) {
  let isAnyCanalVenda = false;
  let isLojaDataLayer = false;
  const socialMedia = getParameter('socialMedia');
  const segmentoUrl = getParameter('segmento');

  const filtroLetra = $('#letraDoFiltro a.selected').attr('data-letraFiltro');
  const filtroCanalVenda = $('.clickFiltroRapido.selected.active-quick-filter')
    .map(function () {
      return $(this).attr('data-filtroRapido');
    })
    .toArray();

  let filtroSegmento = '';
  let filtroSubSegmento = '';
  let filtroTipoEntrega = '';

  if (socialMedia && socialMedia != '') isAnyCanalVenda = socialMedia.toUpperCase() == 'ALL';

  if (navigator.userAgent.match('Mobile') != null) {
    filtroTipoEntrega = $('#filtroTipoEntregaMobile').val();
    filtroSegmento = isAlimentacao ? '' : $('#filtroSegmentosMobile').val();
    filtroSubSegmento = isAlimentacao ? $('#filtroSegmentosMobile').val() : '';
  } else {
    filtroTipoEntrega = $('.clickTipoEntrega.selected').attr('data-tipoEntregaFiltro');
    filtroSegmento = isAlimentacao
      ? ''
      : $('.clickFiltroSegmento.selected').attr('data-segmentoFiltro');
    filtroSubSegmento = isAlimentacao
      ? $('.clickFiltroSubSegmento.selected').attr('data-subSegmentoFiltro')
      : '';
  }

  $(element).each(function () {
    const letra = $(this).attr('data-letra');
    const segmento = $(this).attr('data-segmento');
    const subsegmento = $(this).attr('data-subsegmento');
    const canalvenda = $(this).attr('data-canalvenda');
    const tipoEntrega = $(this).attr('data-tipoentrega');
    const filtroNomeNotEmpty = filtroNome && filtroNome != '';
    const filtroSegmentoNotEmpty = filtroSegmento && filtroSegmento !== '';
    const filtroSubSegmentoNotEmpty = filtroSubSegmento && filtroSubSegmento !== '';
    const segmentoUrlNotEmpty = segmentoUrl && segmentoUrl !== '';
    const filtroLetraNotEmpty = filtroLetra && filtroLetra !== '';
    const filtroCanalVendaNotEmpty = filtroCanalVenda && filtroCanalVenda !== '';
    const filtroTipoEntregaNotEmpty = filtroTipoEntrega && filtroTipoEntrega !== '';

    if (!isScroll && $('.store-page__stores--item:visible').length >= 20) {
      return false;
    } else if (isScroll) {
      let count = 1;

      $(element).each(function () {
        if ($(this).is(':visible')) count++;
      });

      if (count >= 20) return false;
    }

    if (filtroNomeNotEmpty) {
      const nome = $(this).attr('data-nome');

      if (filtroNome === nome) {
        if (isLojaDataLayer === false) {
          dataLayerLojaTermoBuscado(filtroNome);
          isLojaDataLayer = true;
        }
        $(this).show();
      } else {
        $(this).hide();
      }

      return;
    }

    if (filtroSegmentoNotEmpty) {
      const existeSegmento = filtroSegmento.toUpperCase() === segmento.toUpperCase();
      if (!existeSegmento) {
        $(this).hide().addClass('not-filtered');
        return;
      }
    }

    if (filtroSubSegmentoNotEmpty) {
      const existeSubSegmento = subsegmento
        .split('#')
        .some(subSegmentoItem => filtroSubSegmento.toUpperCase() === subSegmentoItem.toUpperCase());
      if (!existeSubSegmento) {
        $(this).hide().addClass('not-filtered');
        return;
      }
    }

    if (segmentoUrlNotEmpty) {
      const existeSubSegmento = subsegmento
        .split('#')
        .some(subSegmentoItem => segmentoUrl.toUpperCase() === subSegmentoItem.toUpperCase());
      if (!existeSubSegmento) {
        $(this).hide().addClass('not-filtered');
        return;
      }
    }

    if (filtroLetraNotEmpty) {
      if (letra.toUpperCase() !== filtroLetra.toUpperCase()) {
        $(this).hide().addClass('not-filtered');
        return;
      }
    }

    if (filtroCanalVendaNotEmpty) {
      const existeCanalVenda = filtroCanalVenda.every(r => canalvenda.split('#').includes(r));
      if (!existeCanalVenda) {
        $(this).hide().addClass('not-filtered');
        return;
      }
    } else if (isAnyCanalVenda && (!canalvenda || canalvenda === '')) {
      $(this).hide().addClass('not-filtered');
      return;
    }

    if (filtroTipoEntregaNotEmpty) {
      const existeTipoEntrega = tipoEntrega
        .split('#')
        .some(tipoEntregaItem => filtroTipoEntrega.toUpperCase() === tipoEntregaItem.toUpperCase());
      if (!existeTipoEntrega) {
        $(this).hide().addClass('not-filtered');
        return;
      }
    }

    $(this).show().removeClass('not-filtered');
  });
}

function normalizeLetra(str) {
  if (!str || str === '') return '';

  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

function carregaQtdLojasTipoEntrega() {
  $('#filtroTipoEntrega li a').each(function () {
    const tipoEntregaFiltro = $(this).attr('data-tipoentregafiltro');
    const qtdLojasFiltroTipoEntrega = $('.store-page__stores').find(
      `.store-page__stores--item[data-tipoentrega*="${tipoEntregaFiltro}"]`,
    ).length;

    $(this).find('.tipoentrega__stores--qtd').text(` (${qtdLojasFiltroTipoEntrega})`);
  });
}

function carregaQtdLojasSegmentos() {
  $('#divSegmentos li a').each(function () {
    const segmentoFiltro = $(this).attr('data-segmentoFiltro');
    const qtdLojasFiltroSegmento = $('.store-page__stores').find(
      `.store-page__stores--item[data-segmento*="${segmentoFiltro}"]`,
    ).length;

    $(this).find('.subsegmento__stores--qtd').text(` (${qtdLojasFiltroSegmento})`);
  });
}

function carregaQtdLojasSubSegmentos() {
  $('#divSegmentos li a').each(function () {
    const subSegmentoFiltro = $(this).attr('data-subSegmentoFiltro');
    const qtdLojasFiltroSubSegmento = $('.store-page__stores').find(
      `.store-page__stores--item[data-subsegmento*="${subSegmentoFiltro}"]`,
    ).length;

    $(this).find('.subsegmento__stores--qtd').text(` (${qtdLojasFiltroSubSegmento})`);
  });
}

$('#filtroTipoEntregaMobile').change(() => {
  const $storeSearch = $('#storeSearch');

  if (!alterouTipoEntregaMobile) {
    filtrosSelecionados++;
    atualizaNumeroFiltrosSelecionados();

    if ($storeSearch.val().length !== 0) {
      $storeSearch.val('');
      filtrosSelecionados = 1;
      atualizaNumeroFiltrosSelecionados();
    }
  }

  filtraLoja();
  alterouTipoEntregaMobile = true;
});

$('#filtroSegmentosMobile').change(function () {
  const selectedOption = $(this).find('option:selected');
  const tipoFiltro = selectedOption.data('tipofiltro');

  if (tipoFiltro === 'SUBSEGMENTO' && selectedOption.text().trim() === 'Restaurantes') {
    window.location.href = '/restaurantes';
    return;
  }

  const $storeSearch = $('#storeSearch');

  if (!alterouSegmentoMobile) {
    filtrosSelecionados++;
    atualizaNumeroFiltrosSelecionados();

    if ($storeSearch.val().length !== 0) {
      $storeSearch.val('');
      filtrosSelecionados = 1;
      atualizaNumeroFiltrosSelecionados();
    }
  }

  filtraLoja();
  alterouSegmentoMobile = true;
});

function clickSegmento(element) {
  const $storeSearch = $('#storeSearch');
  const $clickFiltroSegmento = $('.clickFiltroSegmento, .clickFiltroSubSegmento');
  const isSelected = $(element).hasClass('selected');

  if (!alterouSegmento) {
    if ($storeSearch.val().length !== 0) {
      $storeSearch.val('');
      filtrosSelecionados = 0;
      atualizaNumeroFiltrosSelecionados();
    }
  }

  if (!isSelected) {
    $clickFiltroSegmento.removeClass('selected active-segmento');
    $(element).addClass('selected active-segmento');

    if (!alterouSegmento) {
      filtrosSelecionados++;
      atualizaNumeroFiltrosSelecionados();
    }

    filtraLoja();

    alterouSegmento = true;
  } else {
    $clickFiltroSegmento.removeClass('selected active-segmento');
    filtrosSelecionados--;

    atualizaNumeroFiltrosSelecionados();
    filtraLoja();

    alterouSegmento = false;
  }
}

function clickFiltroRapido(element) {
  const $storeSearch = $('#storeSearch');
  const isSelected = $(element).hasClass('selected');

  if ($storeSearch.val().length !== 0) {
    $storeSearch.val('');
    filtrosSelecionados = 0;
    atualizaNumeroFiltrosSelecionados();
  }

  if (!isSelected) {
    $(element).addClass('selected active-quick-filter');

    filtrosSelecionados++;
    atualizaNumeroFiltrosSelecionados();
    filtraLoja();
  } else {
    $(element).removeClass('selected active-quick-filter');

    filtrosSelecionados--;
    atualizaNumeroFiltrosSelecionados();
    filtraLoja();
  }
}

function clickTipoEntrega(element) {
  const $storeSearch = $('#storeSearch');
  const $filtroTipoEntrega = $('#filtroTipoEntrega a');
  const isSelected = $(element).hasClass('selected');

  if (!alterouTipoEntrega) {
    if ($storeSearch.val().length !== 0) {
      $storeSearch.val('');
      filtrosSelecionados = 0;
      atualizaNumeroFiltrosSelecionados();
    }
  }

  if (!isSelected) {
    $filtroTipoEntrega.removeClass('selected active-delivery');
    $(element).addClass('selected active-delivery');

    if (!alterouTipoEntrega) {
      filtrosSelecionados++;
      atualizaNumeroFiltrosSelecionados();
    }

    filtraLoja();

    alterouTipoEntrega = true;
  } else {
    $filtroTipoEntrega.removeClass('selected active-delivery');
    filtrosSelecionados--;

    atualizaNumeroFiltrosSelecionados();
    filtraLoja();

    alterouTipoEntrega = false;
  }
}

function clickLetra(element) {
  const $storeSearch = $('#storeSearch');
  const $letraDoFiltro = $('#letraDoFiltro a');
  const isSelected = $(element).hasClass('selected');

  if (!alterouLetra) {
    if ($storeSearch.val().length !== 0) {
      $storeSearch.val('');
      filtrosSelecionados = 0;
      atualizaNumeroFiltrosSelecionados();
    }
  }

  if (!isSelected) {
    $letraDoFiltro
      .removeClass('active-letra selected')
      .filter(element)
      .addClass('selected active-letra');

    if (!alterouLetra) {
      filtrosSelecionados++;
      atualizaNumeroFiltrosSelecionados();
    }

    filtraLoja();
    dataLayerClickLetraFiltro($(element).text());

    alterouLetra = true;
  } else {
    $letraDoFiltro.removeClass('selected active-letra');
    filtrosSelecionados--;

    atualizaNumeroFiltrosSelecionados();
    filtraLoja();

    alterouLetra = false;
  }
}

function buildStore(store, letraParam, letraParamOld, index, lojaLength) {
  const { nome } = store;

  let nomeLoja = nome;
  const nomeLojaIntegracao = nomeLoja;
  const pavimentos = store.pavimento;
  const pavimentosInserted = [];
  const metaTitle = $("meta[name='application-name']").attr('content');
  const shoppingTitle = metaTitle || 'Shopping';
  const isHiddenLoja = index + 1 > 20;
  const hiddenLoja = isHiddenLoja ? 'style="display: none;"' : '';
  const hiddenContainer = isHiddenLoja ? 'hidden-container' : '';
  const randomParam = Math.random();
  const imgLoja = store.imgURL;
  const hiddenImg = isHiddenLoja
    ? `data-src="${imgLoja}"`
    : `data-src="${imgLoja}" style="cursor: pointer; background-image: url(${imgLoja});"`;

  nomeLoja = nomeLoja.replace("'", '`');
  letraParam = normalizeLetra(letraParam);
  letraParamOld = normalizeLetra(letraParamOld);

  let letraFiltro = normalizeLetra(nomeLoja.substring(0, 1));
  let whatsAppMessage = `Olá! Acessei o site do ${shoppingTitle} e tenho interesse em `;
  let hrefDriveThruZap = '';
  let hrefDriveThruLockerZap = '';
  let isZap = false;
  let isFisico = true;
  let hrefDelivery = '';
  let hrefZap = '';
  const hrefEcommerce = '';
  let hrefShoppingDigital = '';
  const hrefDeliverysArray = {};
  let segmento = '';
  let subSegmento = '';
  let htmlSegmento = '';
  let htmlSegmentoList = '';
  let icones = '';
  let canalVenda = '';
  let tipoEntrega = '';
  let htmlNome = '';
  let htmlLojas = '';
  let htmlPavimento = '';
  let htmlPavimentoList = '';
  let counterPavimentos = 0;

  if (/[0-9]/.test(letraFiltro)) {
    letraFiltro = '0-9';
  }

  const normalizedLetter = letraFiltro.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  if (/[^\w-]/.test(normalizedLetter)) {
    letraFiltro = 'SPECIAL';
  }

  if (nomeLoja) {
    htmlNome = `<a href="javascript:;" style="text-decoration: none;color: initial;" onclick="dataLayerCliqueLoja('${nomeLoja}'); linkPageDetails('${store.id}')">${nomeLoja}</a>`;
  }

  if (store.itensSeguimento) {
    store.itensSeguimento.forEach(itemSubSeguimento => {
      if (subSegmento !== '') subSegmento += '#';

      subSegmento += itemSubSeguimento.subseguimento;

      if (isAlimentacao) {
        htmlSegmento += `<span class='store-detail__segment'>${subSegmento} • </span>`;

        htmlSegmentoList += `<span class='store-detail__segment'>
          <img src='/lumis-theme/br/com/alianscesonae/shoppings/theme/aliansce-sonae-shoppings/assets/images/icons/segment-list.svg'
            alt=''
            onload='SVGInject(this)'
          />
          ${subSegmento}
        </span>`;
      }
    });
  }

  if (store.categoria) {
    store.categoria.forEach(itemSegmento => {
      if (segmento !== '') segmento += '#';

      segmento += itemSegmento;

      if (!isAlimentacao) {
        htmlSegmento += `<span class='store-detail__segment'>${itemSegmento} • </span>`;

        htmlSegmentoList += `<span class='store-detail__segment'>
          <img src='/lumis-theme/br/com/alianscesonae/shoppings/theme/aliansce-sonae-shoppings/assets/images/icons/segment-list.svg'
            alt=''
            onload='SVGInject(this)'
          />
          ${itemSegmento}
        </span>`;
      }
    });
  }

  if (pavimentos) {
    pavimentos.forEach(pavimento => {
      if (!pavimentosInserted.includes(pavimento)) {
        if (pavimento.toUpperCase() === 'LOJA ONLINE') {
          isFisico = false;

          htmlPavimentoList += `
          <span class='store-detail__location'>
            <img src='/lumis-theme/br/com/alianscesonae/shoppings/theme/aliansce-sonae-shoppings/assets/images/icons/online-store-card.svg' alt='' onload='SVGInject(this)' />
            LOJA EXCLUSIVA DO SITE
          </span>`;
        } else {
          htmlPavimentoList += `
          <span class='store-detail__location'>
            <img src='/lumis-theme/br/com/alianscesonae/shoppings/theme/aliansce-sonae-shoppings/assets/images/icons/location-list.svg' alt='' onload='SVGInject(this)' />
            ${pavimento}
          </span>`;
        }

        pavimentosInserted.push(pavimento);
      }
    });

    pavimentosInserted.forEach(pavimentoItem => {
      counterPavimentos += 1;

      pavimentoItem = pavimentoItem.toUpperCase();

      if (pavimentosInserted.length === 1) {
        htmlPavimento += `<span class='store-detail__location'>${pavimentoItem}</span>`;
      } else {
        if (counterPavimentos < pavimentosInserted.length) {
          htmlPavimento += `<span class='store-detail__location'>${pavimentoItem} | </span>`;
        } else {
          htmlPavimento += `<span class='store-detail__location'>${pavimentoItem}</span>`;
        }
      }
    });
  } else {
    isFisico = false;
  }

  if (isFisico) canalVenda += 'FISICO';

  if (store.hasValidSocialMidias) {
    whatsAppMessage = encodeURIComponent(whatsAppMessage);

    store.redesSociais.forEach(redeSocial => {
      const { typeId, value } = redeSocial;

      if (typeId === '9' && !isZap) {
        isZap = true;
        hrefZap += `<img class='store-detail__icon' src='/lumis-theme/br/com/alianscesonae/shoppings/theme/aliansce-sonae-shoppings/assets/images/icons/compre-whatsapp.svg' alt='' onload='SVGInject(this)'/>`;
      } else if (typeId === '20') {
        hrefShoppingDigital += `<img class='store-detail__icon' src='/lumis-theme/br/com/alianscesonae/shoppings/theme/aliansce-sonae-shoppings/assets/images/icons/compra-online.svg' alt='' onload='SVGInject(this)'/>`;
      } else if (typeId === '13') {
        hrefDriveThruZap += `<img class='store-detail__icon' src='/lumis-theme/br/com/alianscesonae/shoppings/theme/aliansce-sonae-shoppings/assets/images/icons/compre-whatsapp.svg' alt='' onload='SVGInject(this)'/>`;
      } else if (typeId === '12') {
        hrefDelivery += `<img class='store-detail__icon' src='/lumis-theme/br/com/alianscesonae/shoppings/theme/aliansce-sonae-shoppings/assets/images/icons/peça-delivery.svg' alt='' onload='SVGInject(this)'/>`;
      } else if (typeId === '16') {
        hrefDeliverysArray.ifood = formatURL(value);
      } else if (typeId === '17') {
        hrefDeliverysArray.ubereats = formatURL(value);
      } else if (typeId === '18') {
        hrefDeliverysArray.rappi = formatURL(value);
      } else if (typeId === '19') {
        hrefDeliverysArray.outros = formatURL(value);
      } else if (typeId === '15') {
        hrefDriveThruLockerZap += `<img class='store-detail__icon' src='/lumis-theme/br/com/alianscesonae/shoppings/theme/aliansce-sonae-shoppings/assets/images/icons/compre-whatsapp.svg' alt='' onload='SVGInject(this)'/>`;
      }
    });
  }

  if (hrefShoppingDigital && hrefShoppingDigital !== '') {
    if (canalVenda !== '') canalVenda += '#';

    canalVenda += 'SHOPPINGDIGITAL';
    icones += hrefShoppingDigital;
  }

  if (hrefZap && hrefZap !== '') {
    if (canalVenda !== '') canalVenda += '#';

    canalVenda += 'WHATSAPP';

    if (hrefDriveThruZap && hrefDriveThruZap !== '') {
      canalVenda += '#DRIVETHRU';
    }

    if (hrefDriveThruLockerZap && hrefDriveThruLockerZap !== '') {
      canalVenda += '#DRIVETHRULOCKER';
    }

    icones += hrefZap;
  }

  if (hrefDeliverysArray && Object.keys(hrefDeliverysArray).length) {
    if (canalVenda) canalVenda += '#';

    canalVenda += 'DELIVERY';
    icones += `<img class='store-detail__icon' src='/lumis-theme/br/com/alianscesonae/shoppings/theme/aliansce-sonae-shoppings/assets/images/icons/peça-delivery.svg' alt='' onload='SVGInject(this)' />`;
  } else if (hrefDelivery) {
    if (canalVenda) canalVenda += '#';

    canalVenda += 'DELIVERY';
    icones += hrefDelivery;
  }

  if (hrefEcommerce && hrefEcommerce != '') {
    if (canalVenda != '') canalVenda += '#';

    canalVenda += 'ECOMMERCE';
    icones += hrefEcommerce;
  }

  if (canalVenda) {
    if (canalVenda.includes('SHOPPINGDIGITAL')) {
      tipoEntrega = 'PEGSHP#PEGCASA';
    } else {
      if (canalVenda.includes('DELIVERY')) tipoEntrega = 'PEGCASA';

      if (canalVenda.includes('WHATSAPP')) {
        if (tipoEntrega) tipoEntrega += '#';

        tipoEntrega += 'PEGSHP';
      }
    }
  } else {
    tipoEntrega = '';
  }

  if (letraParam !== letraParamOld) {
    if (index !== 0) {
      htmlLojas += '</div>';
    }

    htmlLojas += `<h2 id="infoLetra-${letraParam}" ${hiddenLoja} class="store__container--main-letter infoLetra">`;

    if (letraParam === 'SPECIAL') {
      htmlLojas += '#';
    } else {
      htmlLojas += letraParam;
    }

    htmlLojas += `</h2><div data-letra="${letraFiltro.toUpperCase()}" class="store-page__stores--container ${hiddenContainer}">`;
  }

  htmlLojas += `
  <div id="${
    store.id
  }-div" ${hiddenLoja} class="store-page__stores--item" data-nome="${nomeLojaIntegracao}"
    data-segmento="${segmento}" data-canalvenda="${canalVenda}" data-subsegmento="${subSegmento}"
    data-letra="${letraFiltro.toUpperCase()}" data-tipoentrega="${tipoEntrega}">
    <div class="store-detail__container ${isFisico ? '' : 'online-store'}">
      <div class="store-detail__image" onclick="dataLayerCliqueLoja('${nomeLoja}'); linkPageDetails('${
        store.id
      }')"
        ${hiddenImg}>
        <div class="online-store__container">
          <span>Loja exclusiva do site</span>
          <img src="/lumis-theme/br/com/alianscesonae/shoppings/theme/aliansce-sonae-shoppings/assets/images/icons/online-store-card.svg" alt="" onload="SVGInject(this)" />
        </div>
      </div>
      <div class="store-detail__info">
        <div class="store-detail__wrapper store-detail__info--grid visible-info">
          ${htmlSegmento}
          ${htmlPavimento}
        </div>
        <div class="store-detail__wrapper">
          ${htmlNome}
          ${icones}
        </div>
        <div class="store-detail__wrapper store-detail__info--list">
          ${htmlSegmentoList}
          ${htmlPavimentoList}
        </div>
      </div>
    </div>
    <div data-nomeLoja="${nomeLoja}" style="display: none" id="${store.id}-cupom"></div>
  </div>`;

  if (letraParam === letraParamOld && index + 1 === lojaLength) {
    htmlLojas += '</div>';
  }

  return htmlLojas;
}

function montaNumeroZap(numeroWpp) {
  if (numeroWpp) {
    numeroWpp = numeroWpp.replace(/([^\w]+|\s+)/g, '');

    if (numeroWpp.length > 2 && !numeroWpp.startsWith('55')) numeroWpp = '55' + numeroWpp;
  } else {
    return '';
  }

  return numeroWpp;
}

function montaModalDriveThru(nomeLoja, telLoja) {
  $('#nomeLojaCanalVendaModal').text(nomeLoja);
  $('#canalVendaConteudoModal').html('<p><a href="tel:' + telLoja + '">' + telLoja + '</a></p>');
  $('#modal-canalVenda').addClass('is-open');
}

function montaModalCupom(nomeLoja, element) {
  const cupomId = $(element).attr('data-cupomId').split('#');
  const cupomDesc = $(element).attr('data-cupomDesc').split('#');
  let htmlCupom = '';

  for (let i = 0; i < cupomId.length; i++) {
    htmlCupom += '<p>' + cupomId[i] + ' - ' + cupomDesc[i] + '</p>';
  }

  $('#nomeLojaCanalVendaModal').text(nomeLoja);
  $('#canalVendaConteudoModal').html(htmlCupom);
  $('#modal-canalVenda').addClass('is-open');
}

function montaModalDelivery(nomeLoja, element) {
  $('#nomeLojaCanalVendaModal').text(nomeLoja);

  let hrefsDelivery = $(element).attr('data-delivery');

  hrefsDelivery = JSON.parse(hrefsDelivery);

  let htmlDelivery = '';

  if (hrefsDelivery.ifood != undefined)
    htmlDelivery +=
      '<p><a onclick="dataLayerCliqueBtnLoja(\'' +
      nomeLoja +
      '\',this)" class="store__item__button button_filled-green button_delivery" href="' +
      hrefsDelivery.ifood +
      '">IFOOD</a></p>';
  if (hrefsDelivery.ubereats != undefined)
    htmlDelivery +=
      '<p><a onclick="dataLayerCliqueBtnLoja(\'' +
      nomeLoja +
      '\',this)" class="store__item__button button_filled-green button_delivery" href="' +
      hrefsDelivery.ubereats +
      '">UBEREATS</a></p>';
  if (hrefsDelivery.rappi != undefined)
    htmlDelivery +=
      '<p><a onclick="dataLayerCliqueBtnLoja(\'' +
      nomeLoja +
      '\',this)" class="store__item__button button_filled-green button_delivery" href="' +
      hrefsDelivery.rappi +
      '">RAPPI</a></p>';
  if (hrefsDelivery.outros != undefined)
    htmlDelivery +=
      '<p><a onclick="dataLayerCliqueBtnLoja(\'' +
      nomeLoja +
      '\',this)" class="store__item__button button_filled-green button_delivery" href="' +
      hrefsDelivery.outros +
      '">OUTROS</a></p>';

  $('#canalVendaConteudoModal').html(htmlDelivery);
  $('#modal-canalVenda').addClass('is-open');
}

function formatURL(url) {
  if (url.toUpperCase().indexOf('HTTP') != 0 && url.toUpperCase().indexOf('HTTPS') != 0)
    url = 'http://' + url;

  return url;
}

function sendToGA(storeName, typeButton) {
  if (typeof gtag === 'function') {
    gtag('event', 'Compra Online - Lojas', {
      event_category: 'Compra Online',
      event_label: storeName + ' - ' + typeButton,
    });
  }
}

function gerarCupons() {
  const shoppingId = $('#empreendimentoId').attr('title');

  $.ajax({
    url: '/lojas/rest/cupons/' + shoppingId,
    type: 'get',
    success: function (data) {
      if (data.httpcode == 200) {
        const json = JSON.parse(data);

        $(json).each((i, loja) => {
          const id = loja.id;
          const storeCuponElement = $('#' + id + '-cupom');

          if (storeCuponElement.length > 0) {
            const cupons = loja.cupons;
            let cupomId = '';
            let cupomDescricao = '';
            let nomeLoja = $(storeCuponElement).attr('data-nomeLoja');
            nomeLoja = nomeLoja.replace("'", '`');
            $(cupons).each((i, cupom) => {
              if (cupomId != '') {
                cupomId += '#';
                cupomDescricao += '#';
              }

              cupomId += cupom.id;
              cupomDescricao += cupom.descricao;
            });

            const lojaDivElemento = $('#' + id + '-div');
            let canalVenda = lojaDivElemento.attr('data-canalvenda');

            if (canalVenda != '') canalVenda += '#CUPONS';
            else canalVenda = 'CUPONS';

            lojaDivElemento.attr('data-canalvenda', canalVenda);

            const isCompraOnline = $('#icone-compra-online-' + id).length > 0;

            if (!isCompraOnline)
              lojaDivElemento.prepend(
                '<a href="javascript:;" onclick="linkPageDetails(\'' +
                  id +
                  '\')" class="online-store-flag">' +
                  '<img src="/lumis-theme/br/com/aliansce/shoppings/theme/shoppings-aliansce/assets/images/icone_sacola.svg" alt="Íconde de loja on-line" onload="SVGInject(this)" />' +
                  '<span>Ver detalhe</span>' +
                  '</a>',
              );

            $(storeCuponElement).replaceWith(
              '<a onclick="sendToGA(\'' +
                nomeLoja +
                "','CÓDIGO/CUPOM');dataLayerCliqueBtnLoja('" +
                nomeLoja +
                "',this); montaModalCupom('" +
                nomeLoja +
                '\',this)" data-cupomId="' +
                cupomId +
                '" data-cupomDesc="' +
                cupomDescricao +
                '">' +
                '<figure class="btn-loja-icon">' +
                '<img src="/lumis-theme/br/com/aliansce/shoppings/theme/shoppings-aliansce/assets/images/icone_cupom.svg" onload="SVGInject(this)"/>' +
                '</figure>CUPOM</a>',
            );
          }
        });
      }
    },
    error: function (error) {
      console.error('Erro ao obter os cupons: ' + error);
    },
  });
}

function linkPageDetails(idLoja) {
  const href = $('#' + idLoja + '-link').attr('href');
  window.location.href = href;
}

function filterURL() {
  const socialMedia = getParameter('socialMedia');

  if (socialMedia && socialMedia != '') {
    $('#loadingLoja').show();
    $('.store-page__stores--item').hide();
    $('.nostores').hide();
    $('.infoLetra').hide();

    setTimeout(() => {
      if (socialMedia.toUpperCase() != 'ALL') {
        $('#filtroCanalVenda').val(socialMedia.toUpperCase());
      }

      filtraLoja();
      $('#loadingLoja').hide();
    }, 2000);
  } else {
    const segmento = getParameter('segmento');

    if (segmento && segmento != '') {
      $('#loadingLoja').show();
      $('.store-page__stores--item').hide();
      $('.nostores').hide();
      $('.infoLetra').hide();

      setTimeout(() => {
        filtraLoja();
        $('#loadingLoja').hide();
      }, 2000);
    }
  }
}

function getParameter(theParameter) {
  const params = window.location.search.substr(1).split('&');

  for (let indexParam = 0; indexParam < params.length; indexParam++) {
    const param = params[indexParam].split('=');

    if (param[0].toUpperCase() == theParameter.toUpperCase()) {
      return decodeURIComponent(param[1]);
    }
  }

  return '';
}

function geraReserva() {
  let reservasLojaShopping;

  $.ajax({
    url: g_LumisRoot_href + 'aliansce/shopping/rest/aliansce/reserva/getReservaShopping',
    type: 'GET',
    success: function (dataReserva) {
      if (dataReserva.httpcode == 200) {
        reservasLojaShopping = JSON.parse(dataReserva.response);

        if (reservasLojaShopping != '' && reservasLojaShopping.length > 0) {
          reservasLojaShopping.forEach(reservasLojaShoppingItem => {
            const lojaDivElemento = $('#' + reservasLojaShoppingItem.idLoja + '-div');

            if (lojaDivElemento && reservasLojaShoppingItem.disponibilidade != '0') {
              let canalVenda = lojaDivElemento.attr('data-canalvenda');

              if (canalVenda != '') canalVenda += '#RESERVA';
              else canalVenda = 'RESERVA';

              lojaDivElemento.attr('data-canalvenda', canalVenda);

              const isCompraOnline =
                $('#icone-compra-online-' + reservasLojaShoppingItem.idLoja).length > 0;

              if (!isCompraOnline)
                lojaDivElemento.prepend(
                  '<a href="javascript:;" onclick="linkPageDetails(\'' +
                    reservasLojaShoppingItem.idLoja +
                    '\')" class="online-store-flag">' +
                    '<img src="/lumis-theme/br/com/aliansce/shoppings/theme/shoppings-aliansce/assets/images/icone_sacola.svg" alt="Íconde de loja on-line" onload="SVGInject(this)" />' +
                    '<span>Ver detalhe</span>' +
                    '</a>',
                );

              const nomeLoja = reservasLojaShoppingItem.nomeRestaurante.replace("'", '`');
              $('#' + reservasLojaShoppingItem.idLoja + '-div footer').append(
                '<a onclick="sendToGA(\'' +
                  nomeLoja +
                  "','reserva');dataLayerCliqueBtnLoja('" +
                  nomeLoja +
                  "',this);verificaReservaLoja('" +
                  reservasLojaShoppingItem.idLoja +
                  '\')" href="javascript:;">' +
                  '<figure class="btn-loja-icon">' +
                  '<img src="/lumis-theme/br/com/aliansce/shoppings/theme/shoppings-aliansce/assets/images/icone_restaurante.svg" onload="SVGInject(this)"/>' +
                  '</figure>Reserva</a>',
              );
            }
          });
        }
      }
    },
  });
}

function verificaReservaLoja(idLoja) {
  $('#loadingModal').addClass('is-open');

  $.ajax({
    url:
      g_LumisRoot_href + 'aliansce/shopping/rest/aliansce/reserva/getReservaLoja?idLoja=' + idLoja,
    type: 'GET',
    success: function (data) {
      if (data.httpcode == 200) {
        reservasLoja = JSON.parse(data.response);

        if (reservasLoja.length > 0) {
          buildDataReserva();

          idLojaGlobal = idLoja;
          nomeLojaGlobal = reservasLoja[0].nomeRestaurante;

          $('.info-nome-loja').text(nomeLojaGlobal);
          $('#modal-reservas-loja').addClass('is-open');
        }
      } else {
        console.error('Erro verificando reserva');
      }

      $('#loadingModal').removeClass('is-open');
    },
    error: function (data) {
      $('#loadingModal').removeClass('is-open');
      console.error('Erro verificando reserva');
    },
  });
}

function buildDataReserva() {
  let dataOld = '';

  $('#data-reserva').empty();
  $('#hora-reserva').empty();
  $('#qtd-pessoas-reserva').empty();
  $('#data-reserva').append('<option disabled selected value="">Selecione a data</option>');

  for (let i = 0; i < reservasLoja.length; i++) {
    const data = reservasLoja[i].dataDisponivel;

    if (dataOld != reservasLoja[i].dataDisponivel)
      $('#data-reserva').append('<option value="' + data + '">' + data + '</option>');

    dataOld = data;
  }
}

function buildHoraReserva(dataDisponivel) {
  $('#qtd-pessoas-reserva').empty();
  $('#hora-reserva').empty();

  $('#hora-reserva').append('<option disabled selected value="">Selecione a hora</option>');

  for (let i = 0; i < reservasLoja.length; i++) {
    if (dataDisponivel == reservasLoja[i].dataDisponivel)
      $('#hora-reserva').append(
        '<option value="' +
          reservasLoja[i].horaDisponivel +
          '">' +
          reservasLoja[i].horaDisponivel +
          '</option>',
      );
  }
}

function buildQuantidadePessoas(dataDisponivel, horaDisponivel) {
  $('#qtd-pessoas-reserva').empty();
  $('#qtd-pessoas-reserva').append(
    '<option disabled selected value="">Selecione a quantidade</option>',
  );

  for (let i = 0; i < reservasLoja.length; i++) {
    if (
      dataDisponivel == reservasLoja[i].dataDisponivel &&
      horaDisponivel == reservasLoja[i].horaDisponivel
    ) {
      let disponibilidade = reservasLoja[i].disponibilidade;

      if (disponibilidade && disponibilidade != '0' && disponibilidade != '') {
        disponibilidade = parseInt(disponibilidade);

        for (let j = 0; j < disponibilidade; j++) {
          $('#qtd-pessoas-reserva').append(
            '<option value="' + (j + 1) + '">' + (j + 1) + '</option>',
          );
        }
      }

      break;
    }
  }
}

function enviaReserva(
  idLojaParam,
  nomeLojaParam,
  dataReservaParam,
  horaReservaParam,
  qtdReservaParam,
) {
  $('#modal-reservas-loja').removeClass('is-open');
  $('#loadingModal').addClass('is-open');

  let dataReserva = $('#data-reserva').val();
  let horaReserva = $('#hora-reserva').val();
  let qtdReserva = $('#qtd-pessoas-reserva').val();
  let idLoja = idLojaGlobal;
  let nomeLoja = nomeLojaGlobal;

  if (idLojaParam && nomeLojaParam && dataReservaParam && horaReservaParam && qtdReservaParam) {
    idLoja = idLojaParam;
    nomeLoja = nomeLojaParam;
    dataReserva = dataReservaParam;
    horaReserva = horaReservaParam;
    qtdReserva = qtdReservaParam;
  }

  dataLayerConfirmaReserva(nomeLojaParam);

  $.ajax({
    url: g_LumisRoot_href + 'aliansce/shopping/rest/aliansce/reserva/putReserva',
    type: 'POST',
    data: {
      idLoja: idLoja,
      nomeLoja: nomeLoja,
      data: dataReserva,
      hora: horaReserva,
      qtdPessoas: qtdReserva,
    },
    success: function (data) {
      if (data.httpcode == 201) {
        $('.info-nome-loja').text(nomeLoja);
        $('#data-info').text(dataReserva);
        $('#hora-info').text(horaReserva);
        $('#qtd-info').text(qtdReserva);
        $('#modal-reservas-sucesso').addClass('is-open');
      } else {
        $('#modal-reservas-erro').addClass('is-open');
      }

      $('#loadingModal').removeClass('is-open');
    },
    error: function (data) {
      $('#loadingModal').removeClass('is-open');
      $('#modal-reservas-erro').addClass('is-open');
    },
  });
}

function redirectB2C() {
  $('#modal-reservas-loja').removeClass('is-open');
  $('#loadingModal').addClass('is-open');

  setCookie('loginOriginUrl', '/usuario/');
  setCookie('lumRequestedPage', window.location.href);

  document.cookie = 'idLojaReserva=' + idLojaGlobal + ';max-age=80;path=/';
  document.cookie = 'nomeLojaReserva=' + nomeLojaGlobal + ';max-age=80;path=/';
  document.cookie = 'dataReserva=' + $('#data-reserva').val() + ';max-age=80;path=/';
  document.cookie = 'horaReserva=' + $('#hora-reserva').val() + ';max-age=80;path=/';
  document.cookie = 'qtdReserva=' + $('#qtd-pessoas-reserva').val() + ';max-age=80;path=/';

  window.location.href = '/usuario/login';
}

function verificaAutenticacao() {
  if (getCookie('lumIsLoggedUser') === 'true') enviaReserva();
  else redirectB2C();
}

function verificaRetornoAutenticacao() {
  const idLojaReserva = LumisPortal.getCookie('idLojaReserva');
  const nomeLojaReserva = LumisPortal.getCookie('nomeLojaReserva');
  const dataReserva = LumisPortal.getCookie('dataReserva');
  const horaReserva = LumisPortal.getCookie('horaReserva');
  const qtdReserva = LumisPortal.getCookie('qtdReserva');

  if (
    idLojaReserva != null &&
    idLojaReserva != '' &&
    nomeLojaReserva != null &&
    nomeLojaReserva != '' &&
    dataReserva != null &&
    dataReserva != '' &&
    horaReserva != null &&
    horaReserva != '' &&
    qtdReserva != null &&
    qtdReserva != ''
  ) {
    document.cookie = 'idLojaReserva=;max-age=80;path=/';
    document.cookie = 'nomeLojaReserva=;max-age=80;path=/';
    document.cookie = 'dataReserva=;max-age=80;path=/';
    document.cookie = 'horaReserva=;max-age=80;path=/';
    document.cookie = 'qtdReserva=;max-age=80;path=/';

    if (getCookie('lumIsLoggedUser') === 'true') {
      enviaReserva(idLojaReserva, nomeLojaReserva, dataReserva, horaReserva, qtdReserva);
    }
  }
}

function processaScroll() {
  const filtroNome = $('#storeSearch').val();

  if (filtroNome !== '') return;

  const lojas = $('.store-page__stores--item:hidden');

  processaLoja(lojas, true);

  $('.store-page__stores--item:visible').each(function (index) {
    const $storeImage = $(this).find('.store-detail__image');
    const letra = $(this).attr('data-letra');

    $storeImage.css('background-image', `url(${$storeImage.attr('data-src')})`);

    $('#infoLetra-' + letra).show();
    $(`.store-page__stores--container[data-letra="${letra}"]`).removeClass('hidden-container');
  });
}

let isLoading = false;

function handleIntersection(entries, observer) {
  entries.forEach(entry => {
    if (entry.isIntersecting && !isLoading) {
      const lojas = $('.store-page__stores--item:hidden:not(.not-filtered)');

      if (lojas.length > 0) {
        isLoading = true;
        $('#loadingIndicator').css('opacity', '1');

        setTimeout(() => {
          processaScroll();

          $('#loadingIndicator').css('opacity', '0');
          isLoading = false;
        }, 500);
      }
    }
  });
}

const options = {
  root: null,
  rootMargin: '0px',
  threshold: 1,
};

const loadingIndicator = $('#loadingIndicator')[0];
const observer = new IntersectionObserver(handleIntersection, options);

observer.observe(loadingIndicator);

function handleOpenWithListClick() {
  $('#openWithGrid').show();
  $(this).hide();

  $('.store-page__stores--container').removeClass('store__show-grid').addClass('store__show-list');

  $('.store-detail__info--grid').removeClass('visible-info');
  $('.store-detail__info--list').addClass('visible-info');
}

function handleOpenWithGridClick() {
  $('#openWithList').show();
  $(this).hide();

  $('.store-page__stores--container').removeClass('store__show-list').addClass('store__show-grid');

  $('.store-detail__info--grid').addClass('visible-info');
  $('.store-detail__info--list').removeClass('visible-info');
}

function handleLetraFiltroClick(e) {
  e.preventDefault();
  clickLetra($(this));
}

function handleWindowSize() {
  const windowWidth = $(window).width();

  if (windowWidth < 1200) {
    moveElementsToMobileView();
    showQuickFilterAndAll();
  } else {
    showQuickFilterAndAll();
  }

  if (windowWidth < 600) {
    moveAlphaNumericSearchToMobileView();
  }
}

function moveElementsToMobileView() {
  $('.store-page__filter__quick-filter').appendTo($('.store-page__filter--mobile'));
  $('.store-page__search__options').appendTo($('.store-page__search__options--mobile'));
}

function showQuickFilterAndAll() {
  $('.store-page__filter__quick-filter').show();
  $('.store-page__filter__all').show();
}

function moveAlphaNumericSearchToMobileView() {
  $('.store-page__search--alpha-numeric').appendTo($('.store-page__search--alpha-numeric--mobile'));
}

function resetFilterClasses() {
  $(
    '#letraDoFiltro a, .clickFiltroSegmento, .clickFiltroSubSegmento, .clickFiltroRapido, #filtroTipoEntrega a',
  ).removeClass('selected active-letra active-segmento active-quick-filter active-delivery');
}

function resetDropdownSelections() {
  $('#filtroSegmentosMobile option:first').prop('selected', 'selected');
  $('#filtroTipoEntregaMobile option:first').prop('selected', 'selected');
}

function resetVariables() {
  alterouTipoEntregaMobile = false;
  alterouSegmentoMobile = false;
  alterouSegmento = false;
  alterouTipoEntrega = false;
  alterouLetra = false;
}

$(document).on('click', '.easy-autocomplete li', function () {
  resetFilterClasses();
  resetDropdownSelections();
  resetVariables();

  filtrosSelecionados = 1;
  atualizaNumeroFiltrosSelecionados();

  filtraLoja($(this).text());
});

$(document).ready(() => {
  verificaRetornoAutenticacao();

  $(window).on('resize', handleWindowSize);
  $('#openWithList').on('click', handleOpenWithListClick);
  $('#openWithGrid').on('click', handleOpenWithGridClick);
  $('#letraDoFiltro a').on('click', handleLetraFiltroClick);

  $('#data-reserva').change(function () {
    buildHoraReserva($(this).val());
  });

  $('#hora-reserva').change(function () {
    buildQuantidadePessoas($('#data-reserva').val(), $(this).val());
  });

  $('#form-reserva').validate({
    submitHandler: function (form) {
      verificaAutenticacao();
    },
  });
});
